import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'js/components/design-system';
import { chequeRunTabItems } from './functions';
import PropTypes from 'prop-types';

const ChequeRunTabs = (props) => {
  const { disabled } = props;
  const { path } = useRouteMatch();
  const { t } = useTranslation();
  return (
    <Tabs
      className="cheque-run-tabs"
      items={chequeRunTabItems(t)}
      currentPath={path}
      disabled={disabled}
    />
  );
};

ChequeRunTabs.propTypes = {
  disabled: PropTypes.bool,
};

export default ChequeRunTabs;
